export const groundworksPublicMountPath = "/groundworks";
export const groundworksPublicMountMetaName = "apf-public-mount-path";

/*
 * The public proxy may mount the site at the base prefix or at a
 * partner-scoped prefix one lowercase DNS-style label below it:
 * /groundworks or /groundworks/<partner>. The proxy owns which partner
 * segments exist; the application accepts only the shape and never treats a
 * deeper application route as a mount.
 */
const groundworksMountPathPattern = /^\/groundworks(\/[a-z0-9-]{1,63})?$/;

export function resolveGroundworksMountPath(mountPath: string | null | undefined): string | undefined {
  return typeof mountPath === "string" && groundworksMountPathPattern.test(mountPath) ? mountPath : undefined;
}

export function resolveGroundworksBasename(mountPath: string | null | undefined): string | undefined {
  return resolveGroundworksMountPath(mountPath);
}

/*
 * Router links inherit the public-mount prefix from the BrowserRouter
 * basename, but plain fetches and download hrefs do not: on the
 * beyondwork.ai/groundworks mount a root-absolute /downloads/... escapes the
 * prefix and 404s. Every direct asset URL therefore resolves through here.
 */
export function resolveAssetBasePath(): string {
  if (typeof document === "undefined") return "";
  const mountPath = document
    .querySelector<HTMLMetaElement>(`meta[name="${groundworksPublicMountMetaName}"]`)
    ?.getAttribute("content");
  return resolveGroundworksMountPath(mountPath) ?? "";
}

export function assetHref(path: string): string {
  return `${resolveAssetBasePath()}${path}`;
}
